import React from 'react';
import { Route } from 'react-router-dom';
import AboutHeaderSection from '../pages/about-header/AboutHeaderSection';
import ProtectedRoute from '../components/global/ProtectedRoute';

const aboutHeaderRoutes = (
    <Route
        path="/about-header/section"
        element={
            <ProtectedRoute requiredPermission="settings.about-header.view">
                <AboutHeaderSection />
            </ProtectedRoute>
        }
    />
);

export default aboutHeaderRoutes;
